module.exports = __webpack_public_path__ + "336f39bb4bfd4c51fdfccc6868ca2ed6.svg";